import { useState } from "react";
import { Anchor, AnimatePresence, Button, H1, Paragraph, Separator, SizableText, Spinner, Theme, View, XStack, YStack, Image, Input as NormalInput } from "tamagui";
import { Input } from "../inputs/components/inputsParts.mjs";
import { FormCard } from "../../../bento/forms/layouts/components/layoutParts.mjs";
import { ActiveButton } from "../../../UtilComponents/CustomButtons.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const SignInScreenControlled = ({
  signInTools
}) => {
  const {
    socialProviders,
    basicAuthProvider
  } = signInTools;
  const H1Props = {
    self: "center",
    size: "$8",
    "$group-window-xs": {
      size: "$7"
    }
  };
  return /* @__PURE__ */jsx(FormCard, {
    children: /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      items: "stretch",
      minW: "100%",
      maxW: "100%",
      gap: "$4",
      "$group-window-gtSm": {
        py: "$4",
        width: 400
      },
      children: [/* @__PURE__ */jsxs(H1, {
        ...H1Props,
        children: ["Sign in to your existing ", /* @__PURE__ */jsx(H1, {
          color: "#85C19D",
          ...H1Props,
          children: "Parity"
        }), " account"]
      }), socialProviders?.length ? /* @__PURE__ */jsx(View, {
        flexDirection: "column",
        gap: "$3",
        width: "100%",
        items: "center",
        children: /* @__PURE__ */jsx(Theme, {
          children: /* @__PURE__ */jsxs(View, {
            flexDirection: "column",
            gap: "$3",
            width: "100%",
            self: "center",
            items: "center",
            children: [/* @__PURE__ */jsx(YStack, {
              justifyContent: "space-evenly",
              gap: "$3",
              children: socialProviders.map((provider, idx) => /* @__PURE__ */jsx(Button, {
                minW: "100%",
                onPress: provider.handler,
                children: provider.logoSrc ? /* @__PURE__ */jsx(Image, {
                  src: provider.logoSrc,
                  style: {
                    width: 20,
                    height: 20
                  }
                }) : /* @__PURE__ */jsxs(Button.Text, {
                  children: ["Sign in with ", provider.providerName]
                })
              }, idx))
            }), /* @__PURE__ */jsxs(XStack, {
              width: "100%",
              alignItems: "center",
              gap: "$4",
              children: [/* @__PURE__ */jsx(Separator, {}), /* @__PURE__ */jsx(Paragraph, {
                children: "Or"
              }), /* @__PURE__ */jsx(Separator, {})]
            })]
          })
        })
      }) : null, /* @__PURE__ */jsxs(View, {
        flexDirection: "column",
        gap: "$3",
        children: [/* @__PURE__ */jsx(View, {
          flexDirection: "column",
          gap: "$1",
          children: /* @__PURE__ */jsxs(Input, {
            size: "$4",
            children: [/* @__PURE__ */jsx(Input.Label, {
              htmlFor: "email",
              children: "Email"
            }), /* @__PURE__ */jsx(NormalInput, {
              id: "email",
              placeholder: "email@example.com",
              onChange: event => {
                basicAuthProvider.setEmail(event.target["value"]);
              }
            })]
          })
        }), /* @__PURE__ */jsx(View, {
          flexDirection: "column",
          gap: "$1",
          children: /* @__PURE__ */jsxs(Input, {
            size: "$4",
            children: [/* @__PURE__ */jsx(View, {
              flexDirection: "row",
              items: "center",
              justify: "space-between",
              children: /* @__PURE__ */jsx(Input.Label, {
                htmlFor: "password",
                children: "Password"
              })
            }), /* @__PURE__ */jsx(NormalInput, {
              textContentType: "password",
              secureTextEntry: true,
              id: "password",
              placeholder: "Enter password",
              onChange: event => basicAuthProvider.setPassword(event.target["value"])
            }), /* @__PURE__ */jsx(ForgotPasswordLink, {})]
          })
        })]
      }), /* @__PURE__ */jsx(Theme, {
        inverse: true,
        children: /* @__PURE__ */jsx(ActiveButton, {
          disabled: basicAuthProvider.status === "loading",
          onPress: basicAuthProvider.handler,
          width: "100%",
          iconAfter: /* @__PURE__ */jsx(AnimatePresence, {
            children: basicAuthProvider.status === "loading" && /* @__PURE__ */jsx(Spinner, {
              color: "$color",
              opacity: 1,
              scale: 1,
              transition: "quick",
              position: "absolute",
              l: "60%",
              enterStyle: {
                opacity: 0,
                scale: 0.5
              },
              exitStyle: {
                opacity: 0,
                scale: 0.5
              }
            }, "loading-spinner")
          }),
          ButtonTextProps: {
            children: "Sign In"
          }
        })
      })]
    })
  });
};
const ForgotPasswordLink = () => {
  return /* @__PURE__ */jsx(Anchor, {
    self: "flex-end",
    href: `#`,
    children: /* @__PURE__ */jsx(Paragraph, {
      color: "$color11",
      hoverStyle: {
        color: "$color12"
      },
      size: "$1",
      mt: "$1",
      children: "Forgot your password?"
    })
  });
};
export { SignInScreenControlled };
//# sourceMappingURL=SignInScreen.mjs.map
